/* assets/joiuss-artryon.js */
(function () {
  const TRYON_JQ = "https://joiuss.artryon.cn/tutorial/js/jquery-3.3.1.min.js";
  const TRYON_BROWSER_PARSE =
    "https://joiuss.artryon.cn/tutorial/js/load_browser_parse.js";
  const TRYON_ENDPOINT =
    "https://joiuss.artryon.cn/index.php/admin/GetTpl/detail.html";

  /**
   * Mobile-only: the provider re-sizes after load and can stretch the camera feed.
   * This re-applies a stable viewer height/aspect for a few seconds + on resize.
   */
  function lockTryOnAspectMobile() {
    try {
      if (window.innerWidth > 749) return;

      const mount = document.querySelector("#tryon_single_iframe");
      if (!mount) return;

      const media = mount.querySelector("video, canvas, iframe");
      if (!media) return;

      // For iframe widgets, lock the mount itself (provider will resize internals)
        const viewer = mount;

      const apply = () => {
        if (window.innerWidth > 749) return;

        const w = mount.clientWidth;
        if (!w) return;

        // Slightly shorter than 4:5 so we don't waste vertical space
        const targetH = Math.round(w * 1.15);


        // Give the iframe enough height for the provider UI (prevents overlap)
        const cap = Math.round(window.innerHeight * 0.82);
        const finalH = Math.min(targetH, cap);

        viewer.style.height = finalH + "px";
        viewer.style.maxHeight = cap + "px";
        viewer.style.overflow = "hidden";

        media.style.width = "100%";
        media.style.height = "100%";
        media.style.display = "block";
        media.style.border = "0";

        if (media.tagName.toLowerCase() === "video") {
          media.style.objectFit = "cover";
          media.style.objectPosition = "center";
        }
      };

      apply();

      // Re-apply briefly because provider resizes after init
      let ticks = 0;
      const iv = setInterval(() => {
        ticks += 1;
        apply();
        if (ticks >= 12) clearInterval(iv); // ~3s
      }, 250);

      // --- STEP 2: MutationObserver (fight provider resizing) ---

        if (window.__JOIUSS_TRYON_MO__) {
        try { window.__JOIUSS_TRYON_MO__.disconnect(); } catch (e) {}
        }

        const mo = new MutationObserver(() => {
        apply();
        });

        mo.observe(media, {
        attributes: true,
        attributeFilter: ["style", "class"]
        });

        window.__JOIUSS_TRYON_MO__ = mo;


      // Clean up prior observers
      if (window.__JOIUSS_TRYON_RO__) {
        try {
          window.__JOIUSS_TRYON_RO__.disconnect();
        } catch (e) {}
      }

      const ro = new ResizeObserver(() => apply());
      ro.observe(viewer);
      ro.observe(document.documentElement);
      window.__JOIUSS_TRYON_RO__ = ro;

      window.addEventListener(
        "orientationchange",
        () => setTimeout(apply, 200),
        { passive: true }
      );
      window.addEventListener("resize", () => apply(), { passive: true });
    } catch (e) {
      // no-op
    }
  }

  function loadScriptOnce(src) {
    return new Promise((resolve, reject) => {
      const existing = document.querySelector(
        `script[data-tryon-src="${src}"]`
      );
      if (existing) return resolve();

      const s = document.createElement("script");
      s.src = src;
      s.async = true;
      s.setAttribute("data-tryon-src", src);
      s.onload = () => resolve();
      s.onerror = () => reject(new Error("Failed loading: " + src));
      document.head.appendChild(s);
    });
  }

  function ensureDependencies() {
    const hasJQ = typeof window.jQuery !== "undefined";
    const jqPromise = hasJQ ? Promise.resolve() : loadScriptOnce(TRYON_JQ);

    return jqPromise
      .then(() => loadScriptOnce(TRYON_BROWSER_PARSE))
      .catch(() => Promise.resolve());
  }

  function normalizeSkuStr(skuStr) {
    if (!skuStr) return "";
    return skuStr
      .split(",")
      .map((s) => (s || "").trim())
      .filter(Boolean)
      .join(",");
  }

  function getDeviceFlag() {
    // Safer mapping: phones < 500 = m, everything else = pc
    return window.innerWidth < 500 ? "m" : "pc";
  }

  function openModal() {
    const modal = document.querySelector("[data-joiuss-tryon-modal]");
    if (!modal) return;
    modal.removeAttribute("hidden");
    document.documentElement.classList.add("joiuss-tryon-lock");
  }

  function closeModal() {
    const modal = document.querySelector("[data-joiuss-tryon-modal]");
    if (!modal) return;
    modal.setAttribute("hidden", "hidden");
    document.documentElement.classList.remove("joiuss-tryon-lock");
    const mount = document.querySelector("#tryon_single_iframe");
    if (mount) mount.innerHTML = "";
  }

  function fetchBrowserInfoSafe() {
    try {
      if (typeof window.fetch_browser_info === "function") {
        return window.fetch_browser_info();
      }
    } catch (e) {}
    return null;
  }

  function loadTryOnDetail(opts) {
    const sku_str = normalizeSkuStr(opts.skuStr);
    let default_sku = (opts.defaultSku || "").trim();
    const device = opts.device || getDeviceFlag();

    if (!sku_str) {
      console.error("[TryOn] sku_str is null/empty");
      return;
    }

    // Ensure default_sku is one of the provided SKUs
    if (default_sku) {
      const list = sku_str
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      if (!list.includes(default_sku)) {
        console.log(
          "[TryOn] default SKU not in sku list, falling back:",
          default_sku,
          "->",
          list[0]
        );
        default_sku = list[0] || "";
      }
    } else {
      // If default blank, pick first
      default_sku = sku_str.split(",").map((s) => s.trim()).filter(Boolean)[0] || "";
    }

    console.log("[TryOn] sending", {
      device,
      sku_str,
      default_sku,
      domain: window.location.host,
      path: window.location.pathname,
    });

    const $ = window.jQuery;
    const mount = document.querySelector("#tryon_single_iframe");
    if (!mount) {
      console.error("[TryOn] Missing #tryon_single_iframe mount element");
      return;
    }

    $("#tryon_single_iframe").data("sku_str", sku_str);
    if (default_sku) $("#tryon_single_iframe").data("default_sku", default_sku);

    const formdata = new FormData();
    formdata.append("device", device);
    formdata.append("pathname", window.location.pathname);
    formdata.append("sku_str", sku_str);
    formdata.append("default_sku", default_sku);
    formdata.append("category", opts.category || "detail");
    formdata.append("domain", window.location.host);

    const info = fetchBrowserInfoSafe();
    if (info) {
      formdata.append("report_browser", info.browser || "");
      formdata.append("report_system", info.system || "");
      formdata.append("report_device", info.device || "");
      formdata.append(
        "user_agent",
        (navigator.userAgent || "").toLowerCase()
      );
    }

    $("#tryon_single_iframe").fadeIn(100);

    $.ajax({
      url: TRYON_ENDPOINT,
      type: "POST",
      data: formdata,
      cache: false,
      contentType: false,
      processData: false,
      success: function (data) {
        console.log("[TryOn] fetch success");
        $("#tryon_single_iframe").html(data);

        // Lock mobile aspect after the widget injects & initializes
        setTimeout(lockTryOnAspectMobile, 50);
        setTimeout(lockTryOnAspectMobile, 400);
      },
      error: function () {
        console.log("[TryOn] fetch error");
        $("#tryon_single_iframe").html(
          '<div class="joiuss-tryon-error">' +
            "<p><strong>Try-on is unavailable right now.</strong></p>" +
            "<p>This can happen on preview/dev domains if the provider hasn’t whitelisted the domain/IP yet.</p>" +
            "</div>"
        );
      },
    });
  }

  // Public API
  window.JoiussTryOn = {
    open: function ({ skuStr, defaultSku, category } = {}) {
      ensureDependencies().then(() => {
        openModal();
        loadTryOnDetail({
          skuStr,
          defaultSku,
          category: category || "detail",
          device: getDeviceFlag(),
        });
      });
    },
    close: closeModal,
  };

    // Close handlers (overlay + X + ESC)
    // Capture = more reliable if injected content interferes with bubbling
        document.addEventListener(
        "click",
        function (e) {
            const closeBtn = e.target.closest("[data-joiuss-tryon-close]");
            const overlay = e.target.closest("[data-joiuss-tryon-overlay]");

            // ✅ Tool-injected close button
            const toolClose = e.target.closest(".close_btn");

            if (closeBtn || overlay || toolClose) {
            e.preventDefault();
            e.stopPropagation();
            closeModal();
            }
        },
        true
        );
    

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") closeModal();
    });

    function closeJoiussTryonModal() {
    const modal = document.querySelector('.joiuss-tryon-modal');

    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    // Safety: remove body lock if you’re using one
    document.body.classList.remove('overflow-hidden');

    // Optional: clear iframe/tool container if you inject dynamically
    const toolContainer = modal.querySelector('[data-tryon-container]');
    if (toolContainer) {
        toolContainer.innerHTML = '';
    }
    }




})();
